import type { CustomIconProps } from '../CustomIcon';

export const VaultIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size * 1.042}
      height={size}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.185 2H7.814C4.548 2 2.5 4.312 2.5 7.585v8.83C2.5 19.688 4.537 22 7.814 22h9.37c3.277 0 5.316-2.312 5.316-5.585v-8.83C22.5 4.312 20.461 2 17.185 2Z'
        fill={solid ? color : 'none'}
        stroke={solid ? color : secondaryColor}
        strokeWidth={1.5}
      />
      <circle cx={10.5} cy={12} r={3} stroke={secondaryColor} strokeWidth={1.5} />
      <circle cx={17.5} cy={8} r={1} fill={secondaryColor} />
      <circle cx={17.5} cy={16} r={1} fill={secondaryColor} />
      <circle cx={17.5} cy={12} r={1} fill={secondaryColor} />
    </svg>
  );
};
